import { ISearchParams, SearchStatus } from 'src/utilities/useSearchHooks';
import {
  TableState,
  SearchFilters,
  TableAdapterStatus,
} from 'src/components/DataTable/types/DataTable';

export function mapTableStateToSearchParams<TFilters = SearchFilters>(
  state: TableState<TFilters>
): ISearchParams {
  const { query, page, pageSize, sortField, sortOrder, ...filters } = state;

  return {
    page,
    size: pageSize,
    ...(query && { query: query.trim() }),
    ...(sortField && { sort_field: sortField }),
    ...(sortOrder && { sort_order: sortOrder }),
    ...filters,
  };
}

const searchStatusToTableAdapterStatus: Record<
  SearchStatus,
  TableAdapterStatus
> = {
  [SearchStatus.IDLE]: TableAdapterStatus.SUCCESS,
  [SearchStatus.LOADING]: TableAdapterStatus.LOADING,
  [SearchStatus.COMPLETE]: TableAdapterStatus.SUCCESS,
  [SearchStatus.ERROR]: TableAdapterStatus.ERROR,
};

export function mapSearchStatusToTableAdapterStatus(
  searchStatus: SearchStatus
): TableAdapterStatus {
  return searchStatusToTableAdapterStatus[searchStatus];
}
